import { render, staticRenderFns } from "./InfoPreventa.vue?vue&type=template&id=7d81fe42"
import script from "./InfoPreventa.vue?vue&type=script&lang=js"
export * from "./InfoPreventa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports